import { io } from "socket.io-client";
import EventEmitter from "events";

let socket;
const socketEventEmitter = new EventEmitter();

const connectSocket = (serverUrl, userId, options = {}) => {
    const { copyJobId } = options;
    
    if (!socket) {
        const query = { userId };
        if (copyJobId) {
            query.copyJobId = copyJobId;
        }
        
        if (serverUrl === "/api") {
            socket = io("", {
                path: "/socket.io/",
                query,
            });
        } else {
            socket = io(serverUrl, {
                query,
            });
        }

        socket.on("connect", () => {
            console.log("Connected to WebSocket server");
        });

        socket.on("disconnect", () => {
            console.log("Disconnected from WebSocket server");
        });

        // Register taskCompleted event
        socket.on("taskCompleted", (data) => {
            socketEventEmitter.emit("taskCompleted", data);
        });

        // Register taskActivated event
        socket.on("taskActivated", (data) => {
            socketEventEmitter.emit("taskActivated", data);
        });

        // Register taskFailed event
        socket.on("taskFailed", (data) => {
            console.log("Task failed:", data);
            socketEventEmitter.emit("taskFailed", data);
        });

        // Register taskLoadUpdate event
        socket.on("taskLoadUpdate", (data) => {
            socketEventEmitter.emit("taskLoadUpdate", data);
        });

        // Register loginStageUpdate event
        socket.on("login_stage_update", (data) => {
            socketEventEmitter.emit("login_stage_update", data);
        });

        // Journey status updates
        socket.on("journey:updated", (data) => {
            socketEventEmitter.emit("journey:updated", data);
        });

        // Register quotaExceeded event
        socket.on("quotaExceeded", (data) => {
            socketEventEmitter.emit("quotaExceeded", data);
        });

        // Register newTaskAdded event
        socket.on("newTaskAdded", (data) => {
            socketEventEmitter.emit("newTaskAdded", data);
        });

        // Register copyJobUpdate event (for demo project cloning progress)
        socket.on("copyJobUpdate", (data) => {
            socketEventEmitter.emit("copyJobUpdate", data);
        });
    }

    return socketEventEmitter;
};

// Subscribe to a specific copyJob room
const subscribeToCopyJob = (jobId) => {
    if (socket && jobId) {
        socket.emit("subscribeToCopyJob", jobId);
    }
};

// Disconnect socket (for cleanup)
const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};

export { connectSocket, socketEventEmitter, subscribeToCopyJob, disconnectSocket };
